import type { IntlShape } from 'react-intl';
import { COVER_REDO_KINDS, type CoverRedoKind } from 'fym-shared/src/music24/coverRedo';
import { coverRedoMessages as messages } from './coverRedoMessages';

const KIND_CHIP = {
  images: messages.kindImages,
  coverSizes: messages.kindCoverSizes,
  linkPreview: messages.kindLinkPreview,
  shortVideos: messages.kindShortVideos,
  fullVideos: messages.kindFullVideos,
  musicVideo: messages.kindMusicVideo,
  aiReels: messages.kindAiReels,
} as const;

export const KIND_GROUP = {
  images: messages.groupImages,
  coverSizes: messages.groupCoverSizes,
  linkPreview: messages.groupLinkPreview,
  shortVideos: messages.groupShortVideos,
  fullVideos: messages.groupFullVideos,
  musicVideo: messages.groupMusicVideo,
  aiReels: messages.groupAiReels,
} as const;

/** The chips of the banner: one per group with a file, in the order of the sheet (a1). */
export function kindChips(
  intl: IntlShape,
  counts: Record<CoverRedoKind, number>
): Array<{ kind: CoverRedoKind; text: string }> {
  return COVER_REDO_KINDS.filter((kind) => counts[kind] > 0).map((kind) => ({
    kind,
    text: intl.formatMessage(KIND_CHIP[kind], { count: counts[kind] }),
  }));
}
